export default "__VITE_ASSET__c5a53deb__"